'use strict'
var numeral = require('numeral');
Object.defineProperty(exports, '__esModule', { value: true });
exports.default = numeral;
